import PropTypes from 'prop-types';
import * as React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import StudySummaryDetails from '../../../common/study_summary_details/StudySummaryDetails';
import {
  AGG_BY_SURVEY_TYPE_SORT_ARRAY,
  AGGREGATION_ITEMS,
  AGGREGATIONS_IDS,
} from '../../constants/aggregations';
import { getItems, getTableColumnDefinitions, transformDualAllocationSurveyData } from './utils';
import SURVEY_STATUSES from '../../constants/surveyStatuses';
import { STUDY_TYPE } from '../../../../../../redux/reducers/studyTypeReducers';
import { SURVEY_TYPE_CONFIG } from '../../constants/metrics';
import { SURVEY_TYPE } from '../../../../../../common/components/pdf_generator/templates/SurveyPDFTemplate/utils/DataUtils';

const SurveyStatusDetails = ({ surveysStudySummary, isSurveysStudySummaryLoading, studyType }) => {
  const isDualAllocationStudy =
    studyType === STUDY_TYPE.US_DUAL_ALLOCATION || studyType === STUDY_TYPE.UK_DUAL_ALLOCATION;

  const aggregationData = transformDualAllocationSurveyData(
    surveysStudySummary,
    isDualAllocationStudy,
    SURVEY_TYPE_CONFIG[studyType] || [SURVEY_TYPE.LABOR],
  );
  return (
    <StudySummaryDetails
      heading="Survey status"
      dataValueSuffix="surveys"
      aggregation={aggregationData}
      isAggregationLoading={isSurveysStudySummaryLoading}
      initialSelectedAggId={AGGREGATIONS_IDS.BY_SURVEY_TYPE}
      aggItems={AGGREGATION_ITEMS}
      aggTypes={SURVEY_STATUSES}
      getItems={getItems}
      getColumnDefinitions={getTableColumnDefinitions}
      yTile="Surveys"
      xDomainSortArray={AGG_BY_SURVEY_TYPE_SORT_ARRAY}
    />
  );
};

SurveyStatusDetails.propTypes = {
  surveysStudySummary: PropTypes.object,
  isSurveysStudySummaryLoading: PropTypes.bool,
  studyType: PropTypes.string,
};

SurveyStatusDetails.defaultProps = {
  surveysStudySummary: {},
  isSurveysStudySummaryLoading: false,
  studyType: null,
};

export default connect(state => ({
  studyType: get(state, 'studyType.studyType'),
}))(SurveyStatusDetails);
